/**
 * Afuna Aromatics — Aromatic Notes interactive triptych (R4 item 6).
 *
 * A lightweight tabs pattern: three panels (role="tab") select one shared
 * name + description region beneath the triptych. First note selected by
 * default. Mouse, touch and keyboard (Left/Right/Home/End + Enter/Space)
 * all work; a roving tabindex keeps the group a single tab stop. No
 * carousel, no horizontal overflow. State is in-memory only.
 */
(function () {
  function enhance(root) {
    var tablist = root.querySelector('.aa-notes-triptych__panels');
    var tabs = root.querySelectorAll('.aa-notes-triptych__panel');
    if (!tablist || tabs.length === 0) return;

    function select(index, opts) {
      opts = opts || {};
      var found = false;
      tabs.forEach(function (tab) {
        var isMatch = tab.getAttribute('data-note-index') === String(index);
        tab.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        tab.tabIndex = isMatch ? 0 : -1;
        if (isMatch) found = true;
      });
      if (!found) return;
      root.setAttribute('data-active-note', String(index));
      if (opts.focusTab) {
        var active = root.querySelector('.aa-notes-triptych__panel[aria-selected="true"]');
        if (active) active.focus();
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        select(tab.getAttribute('data-note-index'));
      });
    });

    tablist.addEventListener('keydown', function (event) {
      var currentIndex = -1;
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].getAttribute('aria-selected') === 'true') {
          currentIndex = i;
          break;
        }
      }
      if (currentIndex === -1) currentIndex = 0;

      var nextIndex = null;
      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          nextIndex = (currentIndex + 1) % tabs.length;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = tabs.length - 1;
          break;
        default:
          return;
      }
      event.preventDefault();
      select(tabs[nextIndex].getAttribute('data-note-index'), { focusTab: true });
    });

    // Seed the default selection (note 1) without moving focus or scrolling.
    select(tabs[0].getAttribute('data-note-index'));
  }

  document.querySelectorAll('[data-aa-notes-triptych]').forEach(enhance);
})();
